/**
 * HPO A/B router — hpo-theme-ab-launch US-003.
 *
 * Runs on the CONTROL (published Space) theme only. Decides whether a visitor
 * should see the redesign and, if so, redirects them to the unpublished redesign
 * PREVIEW theme via ?preview_theme_id=. Shopify sets a preview cookie, so the
 * visitor stays on the redesign theme for the session (stickiness). The
 * server-side /variant endpoint is deterministic + sticky in ab_experiments and
 * fails safe to "control", so this never blocks the user.
 *
 * Variant TAGGING of analytics events is NOT done here — each theme declares its
 * own variant in settings and analytics__collect.liquid stamps it (theme-self-aware),
 * which avoids a race against this async call before the first pageview fires.
 *
 * Config comes from <meta> tags emitted by analytics__ab-test.liquid:
 *   hpo-experiment-endpoint, hpo-experiment-id, hpo-experiment-variant,
 *   hpo-experiment-redesign-theme-id
 */
(function () {
  "use strict";

  function meta(name) {
    var m = document.querySelector('meta[name="' + name + '"]');
    return m ? (m.getAttribute("content") || "").trim() : "";
  }

  var ENDPOINT = meta("hpo-experiment-endpoint").replace(/\/+$/, "");
  var EXPERIMENT = meta("hpo-experiment-id");
  var THEME_VARIANT = meta("hpo-experiment-variant"); // this theme's own identity
  var REDESIGN_THEME_ID = meta("hpo-experiment-redesign-theme-id");

  // Only the control theme routes; the redesign theme is the destination (no-op).
  if (!ENDPOINT || !EXPERIMENT) return;
  if (THEME_VARIANT !== "control" || !REDESIGN_THEME_ID) return;

  // Never route inside a Shopify preview/AB context or the theme editor.
  var qs = window.location.search || "";
  if (/[?&](?:preview_theme_id|_ab|_fd|_sd)=/.test(qs)) return;
  if (window.Shopify && window.Shopify.designMode) return;

  var CACHE_KEY = "hpo_ab_" + EXPERIMENT;

  function getVid() {
    try {
      if (window.__hpo && window.__hpo.getVisitorId) return window.__hpo.getVisitorId();
    } catch (e) {}
    try {
      return localStorage.getItem("hpo_vid");
    } catch (e) {}
    return null;
  }

  function showLoading() {
    document.documentElement.classList.add("hpo-ab-loading");
  }
  function hideLoading() {
    document.documentElement.classList.remove("hpo-ab-loading");
  }

  function redirectToRedesign() {
    showLoading();
    try {
      var url = new URL(window.location.href);
      url.searchParams.set("preview_theme_id", REDESIGN_THEME_ID);
      url.searchParams.set("pb", "0"); // hide the preview bar
      window.location.replace(url.toString());
    } catch (e) {
      var sep = qs ? "&" : "?";
      window.location.replace(
        window.location.pathname + qs + sep + "preview_theme_id=" + REDESIGN_THEME_ID + "&pb=0"
      );
    }
  }

  // Sticky client cache: act synchronously on subsequent loads (minimal flicker, no refetch).
  var cached = null;
  try {
    cached = localStorage.getItem(CACHE_KEY);
  } catch (e) {}
  if (cached === "redesign") {
    redirectToRedesign();
    return;
  }
  if (cached === "control") return; // stays on Space

  var vid = getVid();
  if (!vid) return; // collector not ready yet; resolve on a later load, stay on control

  // First-time decision — ask the server (sticky, deterministic, CORS-enabled, fail-safe).
  showLoading();
  var done = false;
  var guard = setTimeout(function () {
    if (!done) hideLoading();
  }, 1500);

  fetch(
    ENDPOINT + "/api/experiments/" + encodeURIComponent(EXPERIMENT) + "/variant?vid=" + encodeURIComponent(vid),
    { credentials: "omit" }
  )
    .then(function (r) {
      return r.json();
    })
    .then(function (d) {
      done = true;
      clearTimeout(guard);
      var v = (d && d.variant) || "control";
      try {
        localStorage.setItem(CACHE_KEY, v);
      } catch (e) {}
      if (v === "redesign") redirectToRedesign();
      else hideLoading();
    })
    .catch(function () {
      done = true;
      clearTimeout(guard);
      hideLoading(); // fail-safe: stay on control
    });
})();
